<template>
  <modal name="ReservePopup" width="850px" height="auto" :clickToClose="false">
    <div id="ReservePopup">
      <div class="top">
        <h6>대관 신청서</h6>
        <button @click="btnClose()" class="close">닫기</button>
      </div>
      <div class="contents">
        <table>
          <colgroup>
            <col width="130px" />
            <col width="" />
            <col width="130px" />
            <col width="" />
          </colgroup>
          <tr>
            <th>제목</th>
            <td colspan="3"><input type="text" v-model="title" /></td>
          </tr>
          <tr>
            <th>단체명</th>
            <td colspan="3"><input type="text" v-model="groupName" /></td>
          </tr>
          <tr>
            <th>사업자번호</th>
            <td colspan="3"><input type="text" v-model="bizNumber" /></td>
          </tr>
          <tr>
            <th>행사명</th>
            <td style="border-right: 1px solid #ddd;">
              <input type="text" v-model="eventName" />
            </td>
            <th>담당자</th>
            <td><input type="text" v-model="manager" /></td>
          </tr>
          <tr>
            <th>행사성격</th>
            <td style="border-right: 1px solid #ddd;">
              <input type="text" v-model="eventType" />
            </td>
            <th>연락처</th>
            <td><input type="text" v-model="contact" /></td>
          </tr>
          <tr>
            <th>대관장소</th>
            <td style="border-right: 1px solid #ddd;">
              <select v-model="eventPlace">
                <option v-for="(obj, index) in meetingRoomList" :key="index">
                  {{ obj }}
                </option>
              </select>
            </td>
            <th>E-Mail</th>
            <td><input type="text" v-model="email" /></td>
          </tr>
          <tr>
            <th>인원</th>
            <td style="border-right: 1px solid #ddd;">
              <input type="text" v-model="personnel" />
            </td>
            <th>문의사항</th>
            <td rowspan="3">
              <textarea style="height:200px" v-model="etc"></textarea>
            </td>
          </tr>
          <tr>
            <th>대관일자</th>
            <td style="border-right: 1px solid #ddd;">
              <div class="day">
                <input type="date" v-model="eventStartDate" />
                <input type="date" v-model="eventEndDate" />
              </div>
            </td>
          </tr>
          <tr>
            <th>대관시간</th>
            <td style="border-right: 1px solid #ddd;">
              <div class="day">
                <input type="time" v-model="eventStartTime" />
                <input type="time" v-model="eventEndTime" />
              </div>
            </td>
          </tr>
        </table>

        <ul>
          <li class="input">
            <file-upload
              input-id="files"
              ref="upload2"
              v-model="files"
              :drop="true"
              :multiple="true"
            >
              <h4
                class="fs-18 fc_w"
                style="background: #aaa;   width: 790px; padding: 10px"
              >
                첨부하실 파일을 선택해 주세요.
              </h4>
            </file-upload>

            <div v-if="files.length" class="file_list">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>파일이름</th>
                    <th>크기</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fileObj in files" :key="fileObj.id">
                    <td>
                      <img
                        v-if="fileObj.thumb"
                        :src="fileObj.thumb"
                        width="40"
                        height="auto"
                      />
                      <img
                        v-else
                        :src="fileIcon(fileObj.name)"
                        width="40"
                        height="auto"
                      />
                    </td>
                    <td>{{ fileObj.name }}</td>
                    <td>{{ fileObj.size | formatSize }}</td>
                    <td>
                      <button @click.prevent="$refs.upload2.remove(fileObj)">
                        삭제
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </li>
        </ul>

        <div class="pdt10">
          <ul>
            <li class="tit">유의사항</li>
            <li>
              - 페럼홀 및 세미나실(50인실)은 최소사용 3일전까지 대관 신청
              바랍니다
            </li>
            <li>
              - 행사 관련 안내서가 제작되었을 경유 신청서와 함께 제출하여 주시기
              바랍니다.
            </li>
            <li>- 동시에 2곳 이상 대관 시 기타 문의사항에 기재 바랍니다.</li>
          </ul>
          <button class="end" @click="btnSave">작성완료</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import pm from "../common/protocolManager";
import eventBus from "../common/eventBus";
import { mapGetters, mapMutations, mapActions } from "vuex";

import FileUpload from "vue-upload-component";
import { getThumbIcon } from "../common/util";

export default {
  components: {
    FileUpload
  },
  data: () => ({
    message: "FerrumReservePopup.vue",

    meetingRoomList: [
      "페럼홀 (220석)",
      "세미나실 (50인실)",
      "세미나실 R1, R2 (25인실)",
      "중회의실 M1, M2 (15인실)",
      "중회의실 M3, M4 (10인실)",
      "소회의실 (6~7인실)",
      "문화집회시설 (25평 라운지)"
    ],

    title: "", // 제목
    groupName: "", // 단체명
    bizNumber: "", // 사업자번호
    eventName: "", // 행사명
    eventType: "", //행사성격
    eventPlace: "", // 대관 장소
    personnel: "", // 인원
    eventStartDate: "", // 행사 시작일
    eventEndDate: "", // 행사 종료일
    eventStartTime: "", // 행사 시작 시간
    eventEndTime: "", // 행사 종료 시간
    manager: "", // 담당자
    contact: "", // 연락처
    email: "", // email
    etc: "", // 문의사항
    files: []
  }),
  methods: {
    fileIcon(fileName) {
      return getThumbIcon(fileName);
    },
    btnSave() {
      let formData = new FormData();

      if (this.title == "") {
        alert("제목을 입력해 주세요");
        return;
      }

      if (this.groupName == "") {
        alert("단체명을 입력해 주세요");
        return;
      }
      if (this.eventStartDate == "") {
        alert("행사 시작일을 입력해 주세요");
        return;
      }

      if (this.eventEndDate == "") {
        alert("행사 종료일을 입력해 주세요");
        return;
      }

      if (this.eventStartTime == "") {
        alert("행사 시작 시간을 입력해 주세요");
        return;
      }

      if (this.eventEndTime == "") {
        alert("행사 종료 시간을 입력해 주세요");
        return;
      }

      let stDate = new Date(this.eventStartDate);
      let etDate = new Date(this.eventEndDate);

      if (stDate.getTime() > etDate.getTime()) {
        alert("시작일과 종료일을 확인하세요");
        return;
      }

      formData.append("title", this.title);
      formData.append("groupName", this.groupName);
      formData.append("bizNumber", this.bizNumber);
      formData.append("eventName", this.eventName);
      formData.append("eventType", this.eventType);
      formData.append("eventPlace", this.eventPlace);
      formData.append("personnel", this.personnel);
      formData.append("eventStartDate", this.eventStartDate);
      formData.append("eventEndDate", this.eventEndDate);
      formData.append("eventStartTime", this.eventStartTime);
      formData.append("eventEndTime", this.eventEndTime);
      formData.append("manager", this.manager);
      formData.append("contact", this.contact);
      formData.append("email", this.email);
      formData.append("etc", this.etc);

      for (let i = 0; i < this.files.length; i++) {
        if (typeof this.files[i].file != "undefined") {
          formData.append("file", this.files[i].file);
        }
      }

      let url = "ferrum/insertMeetingRoom";
      pm.fileUpload(url, formData)
        .then(result => {
          console.log("test1 - ok");
          alert("신청이 완료되었습니다.");
          this.btnClose();
        })
        .catch(err => {
          alert("신청 등록에 실패했습니다.");
          console.log("test1 - error");
        });
    },
    btnClose() {
      console.log("btnClose");
      this.$modal.hide("ReservePopup");
      this.$router.go(-1);
    }
  },
  computed: {},
  destroyed() {
    let agent = navigator.userAgent.toLowerCase();
    if (
      (navigator.appName == "Netscape" &&
        navigator.userAgent.search("Trident") != -1) ||
      agent.indexOf("msie") != -1
    ) {
      // alert("인터넷 익스플로러 브라우저 입니다.");

      let bodyStyle = document.getElementById("body").style;
      bodyStyle.setAttribute("overflow", "auto");
    } else {
      // alert("인터넷 익스플로러 브라우저가 아닙니다.");
      document.body.style = "";
    }
  },
  mounted() {
    this.$modal.show("ReservePopup");
    let agent = navigator.userAgent.toLowerCase();
    if (
      (navigator.appName == "Netscape" &&
        navigator.userAgent.search("Trident") != -1) ||
      agent.indexOf("msie") != -1
    ) {
      // alert("인터넷 익스플로러 브라우저 입니다.");

      let bodyStyle = document.getElementById("body").style;
      bodyStyle.setAttribute("overflow", "hidden");
    } else {
      // alert("인터넷 익스플로러 브라우저가 아닙니다.");
      document.body.style = "overflow: hidden;";
    }
  },
  computed: {
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    }
  },
  created() {
    console.log("created - " + this.message);
    this.eventPlace = this.meetingRoomList[0];

    testData1 = this;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sub02/FerrumReservePopup.vue